export default __webpack_public_path__ + "static/media/kitchen5-afterD-768w.dc47c67b.avif";